module.exports = __webpack_public_path__ + "img/Plan1.2ffc5eff.png";